import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const StatisticsPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  min-height: 0;
  margin: ${pxToRem(12)};
  box-sizing: border-box;

  @media (max-width: 1000px) {
    height: auto;
    min-height: calc(100% - ${pxToRem(24)});
  }
`;

export const ContentWrapper = styled.div`
  min-width: 0;
  min-height: 0;
  height: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 0;
  padding: ${pxToRem(32)} ${pxToRem(24)};
  overflow: visible;
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  box-shadow: ${({ theme }) => theme.shadows.md}, ${({ theme }) => theme.shadows.ring};

  @media (max-width: 1000px) {
    height: auto;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(5)};
  margin-bottom: ${pxToRem(22.5)};
`;

export const Title = styled.h1`
  margin: 0;
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${pxToRem(32)};
  font-weight: 700;
  letter-spacing: -0.02em;
`;

export const Subtitle = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.colors.inkSoft};
  font-size: ${pxToRem(17.5)};
`;

export const Toolbar = styled.div`
  position: relative;
  z-index: 20;
  display: flex;
  align-items: center;
  gap: ${pxToRem(12.5)};
  flex-wrap: wrap;
  margin-bottom: ${pxToRem(20)};
`;

export const Hint = styled.div`
  margin-left: auto;
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${pxToRem(16.25)};
  white-space: nowrap;

  @media (max-width: 1000px) {
    width: 100%;
    margin-left: 0;
  }
`;

export const Board = styled.div`
  min-width: 0;
  min-height: 0;
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-template-rows: minmax(0, 0.9fr) minmax(0, 1.25fr);
  gap: ${pxToRem(15)};
  align-items: stretch;

  @media (max-width: 1000px) {
    flex: none;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: none;
    grid-auto-rows: auto;
  }
`;

export const LoadingContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 0;
`;

export const EmptyStateWrapper = styled.div`
  flex: 1;
  display: flex;
  min-height: 0;

  > * {
    flex: 1;
  }
`;
